// extracted by css-extract-rspack-plugin
export default {"paper":"paper___aJlxn"};